import { LoggerService } from '~/services/logger/logger.service';

export const featureRestrictionLogger = new LoggerService({
    featureName: 'feature_restriction',
    featureVersion: 1.0,
    messagePrefix: '[FeatureRestriction]'
});
